import { endpointTrackingBank } from "./base.config";

export const bankCheckList = {
  getBanksByCompany: `${endpointTrackingBank}/v1/bank-import/get-banks`,
  getResponsibleAccountants: `${endpointTrackingBank}/v1/bank-import/get-responsible`,
  getCompanies: `${endpointTrackingBank}/v1/bank-import/get-companies`,
  getAll: `${endpointTrackingBank}/v1/bank-import`,
  updateMonth: `${endpointTrackingBank}/v1/bank-import-month`,
  update: `${endpointTrackingBank}/v1/bank-import`,
  getYears: `${endpointTrackingBank}/v1/bank-import/get-years`,
  delete: `${endpointTrackingBank}/v1/bank-import/:id`,
  inititalData: `${endpointTrackingBank}/v1/bank-import/initial-data`,
  getCountCompanyMissing: `${endpointTrackingBank}/v1/bank-import/get-count-missing`,
  getCountNotUsingBilagsky: `${endpointTrackingBank}/v1/bank-import/get-count-companies-not-using-bilagsky`,
  getDataCompaniesNotUsingBilagsky: `${endpointTrackingBank}/v1/bank-import/get-companies-not-using-bilagsky`,
}